import { Accordion } from "@hcsc-fiber/react";
import React from "react";
import ThirdPartyPanel, { ScopeHtmlContent } from "./ThirdPartyPanel";

export type ThirdPartyAccordionProps = {
  applicationNameAndScopeDescriptions: AppNameAndScopeDescriptions[];
  isLoading: boolean;
  isError: boolean;
  disconnect: (_appName: string) => void;
};
export type AppNameAndScopeDescriptions = {
  applicationName: string;
  scopeDescriptions: ScopeHtmlContent[];
};

const ThirdPartyAccordion: React.FC<ThirdPartyAccordionProps> = ({
  applicationNameAndScopeDescriptions,
  disconnect,
  isError,
}) => {
  if (isError) {
    return null;
  }
  return (
    <div style={{ width: "100%", marginTop: "2rem" }}>
      <Accordion key={applicationNameAndScopeDescriptions.length}>
        {applicationNameAndScopeDescriptions.map(element => (
          <Accordion.Panel title={element.applicationName} key={element.applicationName}>
            <ThirdPartyPanel
              appName={element.applicationName}
              onDisconnect={disconnect}
              scopeDescriptions={element.scopeDescriptions}
            />
          </Accordion.Panel>
        ))}
      </Accordion>
    </div>
  );
};
export default ThirdPartyAccordion;
